export default "__VITE_ASSET__jngK4Uh$__"